import { 
  convertField, 
  getQueryString, 
  getArrayFromEncodedString,
  decodeQueryStringComponent,
  getBaseURL
} from '../../helpers';

import axios from 'axios';
import PROPERTY_SEARCH_FIELD_TYPES from '@assets/data/property-search-field-types';
import { validationMixin } from 'vuelidate';

/*
--  Update Query String --
*/
export const changeErrors = ( { commit }, payload ) => {
  commit('updateErrors', payload);
};

export const changeWarnings = ( { commit }, payload ) => {
  commit('updateWarnings', payload);
};

/*
--  Change Search Params --
*/
export const changeSearchParams = ( { state, rootState, commit, dispatch }, payload ) => {
  return new Promise((resolve, reject) => {
    let fields = Object.keys(payload);
        
    // console.log('changing search params : ', fields);
    // console.log(payload);

    if(fields.length == 0) {
      resolve(false);
      return false;
    }

    try {
      // if(state.searchType == 'for-rent'){
      //   if(fields.includes('min_rent_amt')){
      //     if(isNaN(payload.min_rent_amt) || payload.min_rent_amt == ''){
      //       payload.min_price = '';
      //     } else {
      //       payload.min_price = parseFloat(payload.min_rent_amt);
      //     }
      //   }
      //   if(fields.includes('max_rent_amt')){
      //     if(isNaN(payload.max_rent_amt) || payload.max_rent_amt == ''){
      //       payload.max_price = '';
      //     } else {
      //       payload.max_price = parseFloat(payload.max_rent_amt);
      //     }
      //   }
      // } else if(state.searchType == 'for-sale'){
      //   if(fields.includes('min_asking_price')){
      //     if(isNaN(payload.min_asking_price) || payload.min_asking_price == ''){
      //       payload.min_price = '';
      //     } else {
      //       payload.min_price = parseFloat(payload.min_asking_price);
      //     }
      //   }
      //   if(fields.includes('max_asking_price')){
      //     if(isNaN(payload.max_asking_price) || payload.max_asking_price == ''){
      //       payload.max_price = '';
      //     } else {
      //       payload.max_price = parseFloat(payload.max_asking_price);
      //     }
      //   }
      // }

      commit('updateSearchParams', payload);
      
      /**
       * Do not do this on the saved searches page
       */
      if(rootState.appName !== 'saved-property-search-manage-app'){
        commit('updateQueryString', state.searchType);
        dispatch('changeWindowLocation', {clear: false});
      }
      resolve(payload);
    } catch(e) {
      reject(e);
    }
  });
};

/*
--  Change Search Type --
*/
export const changeSearchType = ( { commit, dispatch }, {searchType} ) => {
  return new Promise((resolve, reject) => {
    try {
      commit('updateSearchType', searchType);
      commit('updateQueryString', searchType);
      dispatch('changeWindowLocation', {clear: false});
      resolve();
    } catch(e) {
      reject(e);
    }
  });
};

const buildRequestQueryString = ({searchParams, fieldsToDelete}) => {
  let searchParams_ = {...searchParams};
  let fieldsToSkip = [];
  fieldsToDelete.forEach(field => delete searchParams_[field]);
  return getQueryString(searchParams_, fieldsToSkip);
};

/*
--  Get Properties Data --
*/
export const getProperties = ( { state, rootState }, {initial = false, query = {}} ) => {

    
  return new Promise((resolve, reject) => {
    let searchType = '';
    if(rootState.appName == 'agent-websites-app') {
      searchType = state.searchParams.listingsType;
    } else {
      searchType = state.searchType;
    }
    let queryString = '';
    let fieldsToDelete = [];
        
    // this is the initial request, make sure the loc_cd is sent with the API request so that the API knows to log the request to the DB
    if(!initial){
      fieldsToDelete.push('loc_cd');
    }
    
    queryString = buildRequestQueryString({
      searchParams: {
        ...state.searchParams,
        ...query
      },
      fieldsToDelete
    });
        
    const requestURL = `/search/properties/${searchType}?${queryString}`;
    // //todo cache this endpoint
    axios.get(requestURL)
      .then(({
        data:{
          properties, 
          markers,
          total_cnt, 
          disclaimer_txt,
          mls_photos,
          mls
        }
      }) => {
        resolve({
          properties, 
          markers, 
          total_cnt, 
          disclaimer_txt,
          mls_photos,
          mls
        });
      })
      .catch(err => {
        reject(err);
      });
  });
    
    
};

/*
--  Update Query String --
*/
export const changeWindowLocation = ( { state, rootState }, {clear} ) => {

  if(!state.searchType) return false;
  // if(!state.initialized) {
  //     console.error('PropertySearchStore :: trying to update query string when state not initialized');
  //     return false;
  // }
  let pathnameArray = window.location.pathname.split('/'); // ["", "search-properties", "for-rent"]

  if(rootState.appName == 'property-search-app') {
    pathnameArray[pathnameArray.length - 1] = state.searchType;
  } else if(rootState.appName == 'agent-websites-app'){
  } else {
    console.error('unahandled scenario');
  }
  let newPathname = pathnameArray.join('/');
  let newUrl = '';
  if(clear){
    newUrl = window.location.protocol + '//' + window.location.host + newPathname;
  } else {
    newUrl = window.location.protocol + '//' + window.location.host + newPathname + '?' + state.queryString;
  }
  //update query string
  if (history.pushState) {
    window.history.pushState({path: newUrl}, '', newUrl);
  }
};

/*
--  Read in initial values from th GET string in the URL, commit to the store --
*/
export const fillInitialValues = ( { dispatch, commit } ) => {
  return new Promise((resolve, reject) => {

    var query = window.location.search.substring(1);
    var vars = query.split('&');
    let dataObj = {};
    for (var i = 0; i < vars.length; i++) {

      var pair = vars[i].split('=');
      let key = pair[0];
      let value = pair[1];

      console.log(pair);
            
      const fieldsToSkip = ['_token', 'action_type'];

      if(!key || fieldsToSkip.includes(key)) continue;

      // when reading in "has_" fields from the URL, send them into the vuex store as Booleans
      if( key.indexOf('has_') == 0 ||
                key == 'section8' ||
                key == 'leased_properties_only'){
        value = Boolean(value);
      } else if((key == 'selected_zipcodes' || key == 'building_types') && !Array.isArray(value)){
        value = getArrayFromEncodedString(value);
      } else if(key == 'location_txt' || key == 'building_type'){
        value = decodeQueryStringComponent(value);
      } else if(key == 'lat' || key == 'lng'){
        // do not use the normal convertField method below for these fields -- it will set them to empty strings if they are less than zero. 
        value = parseFloat(value);
      } else {
        value = convertField(PROPERTY_SEARCH_FIELD_TYPES, key, value, false);
      }

      dataObj[key] = value;

    }

    dispatch('changeSearchParams', dataObj)
      .then(() => {
        resolve(dataObj);
      });
  });
};

export const changeMapView = ( { commit } ) => {
  commit('toggleMapView');
  document.querySelector('body').classList.toggle('rwps-map-open');
};

export const changeBoundsSearchParams = ( { dispatch }, bounds ) => {
  return new Promise((resolve, reject) => {

    if(!bounds) reject('Invalid bounds');
    
    try {
      const jsonBounds = bounds.toJSON();
      
      if(!jsonBounds || !jsonBounds.north || !jsonBounds.south || !jsonBounds.east || !jsonBounds.west) reject({error: 'Invalid params'});
      // console.log(jsonBounds.ia);
      
      
      const min_lng = jsonBounds.west;
      const max_lng = jsonBounds.east;
      
      const min_lat = jsonBounds.south;
      const max_lat = jsonBounds.north;
      
      
      
      const newParams = { min_lat, min_lng, max_lat, max_lng };
      
      dispatch('changeSearchParams', newParams).then(() => {
        resolve(newParams);
      });
    } catch(e) {
      reject(e);
    }
  });
};

export const loadSavedSearch = ( { state, rootState, commit, dispatch }, savedPropertySearch ) => {
  commit('updateSavedPropertySearch', savedPropertySearch);
  commit('updateSearchParams', {ss: savedPropertySearch.id});
  if(rootState.appName !== 'saved-property-search-manage-app'){
    commit('updateQueryString', state.searchType);
    dispatch('changeWindowLocation', {clear: false});
  }
};

/**
* Get Disclaimer
*/
export const getDisclaimer = ( {state, commit}, mls ) => {
  return new Promise((resolve, reject) => {
    try {
      if(!mls) {
        reject('getDisclaimer :: Invalid MLS Name :', mls);
        return false;
      }

      let requestURL = getBaseURL(false) + `/api/disclaimer?mls=${mls}`;

      axios.get(requestURL)
        .then(res => {
          let disclaimer_html = res.data.disclaimer_html;
          let brokerage_footer = res.data.brokerage_footer;
          commit('updateMlsDisclaimer', {mls, text: disclaimer_html});
          commit('updateBrokerageFooter', {mls, text: brokerage_footer});
          resolve(disclaimer_html);
        })
        .catch(err => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};

export const getDisclaimers = ({ state, commit }, mlsList) => {
  return new Promise((resolve, reject) => {
    try {
      if(mlsList.length === 0) {
        reject('getDisclaimersList :: Invalid MLS');
        return false;
      }

      const queryParam = `${mlsList.map(name => `mls[]=${name}`).join('&')}`

      let requestURL = getBaseURL(false) + `/api/disclaimer?${queryParam}`;

      axios.get(requestURL)
          .then(res => {
            let disclaimers = res.data.disclaimer_html;
            let footers = res.data.brokerage_footer;

            commit('updateMlsDisclaimers', disclaimers);
            commit('updateMlsDisclaimersTextList', disclaimers.map(d => d.compliance_text));
            commit('updateBrokerageFootersList', footers);
            commit('updateMlsNames', mlsList);

            resolve(disclaimers);
          })
          .catch(err => {
            reject(err);
          });
    } catch (error) {
      reject(error);
    }
  });
}